if (!customElements.get('arome-delivery-estimate')) {
  customElements.define('arome-delivery-estimate', class extends HTMLElement {
    static get observedAttributes() {
      return ['data-available'];
    }

    connectedCallback() {
      if (!this.dataset.noDateLinkBound) {
        this.dataset.noDateLinkBound = 'true';
        this.addEventListener('click', (event) => {
          const link = event.target?.closest?.('a');
          if (link && this.contains(link)) {
            event.preventDefault();
            event.stopPropagation();
          }
        }, true);
      }
      this.render();
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'data-available' && oldValue !== newValue && this.isConnected) this.render();
    }

    render() {
      const locale = document.documentElement.lang || 'es-MX';
      const available = String(this.dataset.available) !== 'false';
      const startDays = Number(this.dataset.startDays || 3);
      const endDays = Number(this.dataset.endDays || 5);
      const start = new Date();
      const end = new Date();
      start.setDate(start.getDate() + startDays);
      end.setDate(end.getDate() + endDays);

      const day = new Intl.DateTimeFormat(locale, { day: 'numeric' });
      const month = new Intl.DateTimeFormat(locale, { month: 'long' });
      const weekday = new Intl.DateTimeFormat(locale, { weekday: 'long' });
      const target = this.querySelector('[data-delivery-dates]');
      const prefix = this.querySelector('[data-delivery-prefix]');

      this.classList.toggle('is-unavailable', !available);

      if (!available) {
        if (prefix) prefix.textContent = 'Selecciona otra presentación disponible';
        if (target) {
          target.textContent = '';
          target.hidden = true;
        }
        return;
      }

      const isProductPriceDelivery = this.classList.contains('ar-product-price-delivery');
      if (prefix) prefix.textContent = isProductPriceDelivery ? 'Llega entre el' : 'Llega entre';

      if (target) {
        target.hidden = false;
        const startDay = day.format(start);
        const endDay = day.format(end);
        const startMonth = month.format(start).replace('.', '');
        const endMonth = month.format(end).replace('.', '');
        const startWeekday = weekday.format(start);
        const endWeekday = weekday.format(end);

        if (isProductPriceDelivery) {
          target.innerHTML = `<span class="ar-delivery-date-accent">${startWeekday} ${startDay}</span> de ${startMonth} y el <span class="ar-delivery-date-accent">${endWeekday} ${endDay}</span> de ${endMonth}`;
        } else {
          target.innerHTML = `<span class="ar-delivery-date-accent">${startWeekday} ${startDay}</span> de ${startMonth} y <span class="ar-delivery-date-accent">${endWeekday} ${endDay}</span> de ${endMonth}`;
        }
      }
    }
  });
}

(() => {
  const syncProductCtas = () => {
    document.querySelectorAll('button[id^="ProductSubmitButton-"]').forEach((button) => {
      button.classList.add('ar-product-cta');
      const label = button.querySelector(':scope > span:first-child');
      if (!label) return;
      const unavailable = /agotado|no disponible|unavailable|sold out/i.test(label.textContent || '');
      if (!unavailable) label.textContent = 'Agregar al carrito';
    });
  };

  let syncFrame;
  const scheduleSync = () => {
    cancelAnimationFrame(syncFrame);
    syncFrame = requestAnimationFrame(syncProductCtas);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync, { once: true });
  } else {
    scheduleSync();
  }

  new MutationObserver(scheduleSync).observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['disabled']
  });
})();


/* ARÔME mobile sticky purchase reminder */
(() => {
  const initStickyBuy = () => {
    document.querySelectorAll('product-info[id^="MainProduct"]').forEach((root) => {
      if (root.dataset.arStickyBound === 'true') return;
      const mainButton = root.querySelector('button[id^="ProductSubmitButton-"]');
      const sticky = root.querySelector('[data-ar-sticky-buy]');
      const change = sticky?.querySelector('[data-ar-sticky-change]');
      const action = sticky?.querySelector('[data-ar-sticky-action]');
      const variantText = sticky?.querySelector('[data-ar-sticky-variant]');
      const priceText = sticky?.querySelector('[data-ar-sticky-price]');
      const picker = root.querySelector('variant-selects, variant-radios, [id^="variant-selects-"]');
      if (!mainButton || !sticky || !action) return;
      root.dataset.arStickyBound = 'true';

      // Portal the sticky CTA to <body> so iOS/Safari cannot position it
      // relative to a transformed product ancestor.
      if (sticky.parentElement !== document.body) {
        document.body.appendChild(sticky);
      }
      sticky.dataset.arStickyPortaled = 'true';

      const money = new Intl.NumberFormat('es-MX', { style:'currency', currency:'MXN', minimumFractionDigits:0, maximumFractionDigits:2 });
      const scrollToPicker = () => {
        const target = picker || root.querySelector('.product-form__input');
        if (!target) return;
        const y = target.getBoundingClientRect().top + window.scrollY - 96;
        window.scrollTo({ top:y, behavior:'smooth' });
      };
      let lastCartCount = null;
      let updatingCart = false;
      const sync = () => {
        const offerHint = sticky.querySelector('[data-ar-sticky-offer-hint]');
        const actionLabel = action.querySelector('[data-ar-sticky-action-label]');

        if (variantText) {
          variantText.textContent = (variantText.dataset.arProductName || 'Tu perfume')
            .replace(/^inspirad[oa]\s+en\s+/i, '')
            .trim();
        }

        if (actionLabel) actionLabel.textContent = 'Agregar';

        if (offerHint) {
          offerHint.hidden = true;
          offerHint.textContent = '';
        }

        if (priceText) {
          const cartCount = Number(lastCartCount) || 0;
          const displayedPrice = cartCount <= 0
            ? 499
            : cartCount === 1
              ? 374.50
              : 316.33;

          priceText.textContent = money.format(displayedPrice);
        }
      };
      const syncCartPrice = async () => {
        if (updatingCart) return;
        updatingCart = true;
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {credentials:'same-origin',cache:'no-store'});
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          lastCartCount = Number(cart.item_count) || 0;
          sync();
        } catch (_) {
          lastCartCount = null;
          sync();
        } finally { updatingCart = false; }
      };
      const setVisible = (visible) => {
        sticky.hidden = !visible;
        sticky.setAttribute('aria-hidden', String(!visible));
        document.body.classList.toggle('ar-sticky-buy-visible', visible);
      };
      const mobileStickyQuery = window.matchMedia('(max-width: 749px)');
      const updateStickyFromMainButton = () => {
        if (!mobileStickyQuery.matches) {
          setVisible(false);
          return;
        }

        const rect = mainButton.getBoundingClientRect();
        const originalButtonVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        const shouldShowSticky = !originalButtonVisible;

        setVisible(shouldShowSticky);
        if (shouldShowSticky) syncCartPrice();
      };

      const observer = new IntersectionObserver(([entry]) => {
        const shouldShowSticky = mobileStickyQuery.matches && !entry.isIntersecting;
        setVisible(shouldShowSticky);
        if (shouldShowSticky) syncCartPrice();
      }, { threshold:[0, 0.01] });

      observer.observe(mainButton);
      requestAnimationFrame(updateStickyFromMainButton);
      change?.addEventListener('click', () => window.scrollTo({top:0,behavior:'smooth'}));
      action.addEventListener('click', () => {
        if (mainButton.disabled) { scrollToPicker(); return; }
        mainButton.click();
      });
      root.addEventListener('change', () => setTimeout(syncCartPrice, 120));
      document.addEventListener('cart:updated', syncCartPrice);
      document.addEventListener('cart:refresh', syncCartPrice);
      window.addEventListener('pageshow', syncCartPrice);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) syncCartPrice(); });
      mainButton.addEventListener('click', () => setTimeout(syncCartPrice, 1100));
      window.addEventListener('resize', updateStickyFromMainButton);
      mobileStickyQuery.addEventListener?.('change', updateStickyFromMainButton);
      sync();
      syncCartPrice();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyBuy, {once:true});
  else initStickyBuy();
})();

/* ARÔME · formato compacto para fecha global del carrito */
(() => {
  const formatCompactRangeForGlobalCart = () => {
    document.querySelectorAll('arome-delivery-estimate.ar-cart-global-express').forEach((el) => {
      const target = el.querySelector('[data-delivery-dates]');
      const prefix = el.querySelector('[data-delivery-prefix]');
      if (!target) return;

      const startDays = Number(el.dataset.startDays || 2);
      const endDays = Number(el.dataset.endDays || 6);
      const start = new Date();
      const end = new Date();
      start.setDate(start.getDate() + startDays);
      end.setDate(end.getDate() + endDays);

      const locale = document.documentElement.lang || 'es-MX';
      const dayFmt = new Intl.DateTimeFormat(locale, { day: 'numeric' });
      const monthFmt = new Intl.DateTimeFormat(locale, { month: 'short' });

      const startDay = dayFmt.format(start);
      const endDay = dayFmt.format(end);
      const startMonth = monthFmt.format(start).replace('.', '');
      const endMonth = monthFmt.format(end).replace('.', '');

      if (prefix) prefix.textContent = 'Llega entre';
      target.textContent = start.getMonth() === end.getMonth()
        ? `${startDay}–${endDay} ${endMonth}`
        : `${startDay} ${startMonth}–${endDay} ${endMonth}`;
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatCompactRangeForGlobalCart, { once:true });
  } else {
    formatCompactRangeForGlobalCart();
  }

  new MutationObserver(formatCompactRangeForGlobalCart).observe(document.documentElement, {
    childList:true,
    subtree:true
  });
})();

/* ARÔME · fechas dinámicas robustas para carrito */
(() => {
  const updateAromeCartDateRanges = () => {
    const locale = document.documentElement.lang || 'es-MX';
    const dayFmt = new Intl.DateTimeFormat(locale, { day: 'numeric' });
    const monthFmt = new Intl.DateTimeFormat(locale, { month: 'short' });

    document.querySelectorAll('[data-ar-cart-date-range]').forEach((target) => {
      const wrap = target.closest('[data-ar-cart-date-wrap]');
      if (!wrap) return;

      const isGlobal = wrap.classList.contains('ar-cart-global-express');
      const startOffset = isGlobal ? 2 : 3;
      const endOffset = isGlobal ? 6 : 5;

      const start = new Date();
      const end = new Date();
      start.setHours(12,0,0,0);
      end.setHours(12,0,0,0);
      start.setDate(start.getDate() + startOffset);
      end.setDate(end.getDate() + endOffset);

      const sd = dayFmt.format(start);
      const ed = dayFmt.format(end);
      const sm = monthFmt.format(start).replace('.', '');
      const em = monthFmt.format(end).replace('.', '');

      target.textContent = start.getMonth() === end.getMonth()
        ? `${sd}–${ed} ${em}`
        : `${sd} ${sm}–${ed} ${em}`;
    });
  };

  const schedule = () => requestAnimationFrame(updateAromeCartDateRanges);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule, { once:true });
  } else {
    schedule();
  }

  document.addEventListener('cart:updated', schedule);
  document.addEventListener('shopify:section:load', schedule);

  new MutationObserver(schedule).observe(document.documentElement, {
    childList:true,
    subtree:true
  });
})();


/* ARÔME · progreso dinámico de combo en producto */
(() => {
  const updateProductComboProgress = async () => {
    const progressBlocks = document.querySelectorAll('[data-ar-product-combo-progress]');
    if (!progressBlocks.length) return;

    try {
      const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js', {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!response.ok) throw new Error('Cart unavailable');

      const cart = await response.json();
      const qty = Number(cart.item_count) || 0;
      const step = Math.min(qty, 3);
      const pct = (step / 3) * 100;

      const progressMessage = qty <= 0
        ? 'Agrega 2 y paga $749'
        : qty === 1
          ? 'Falta 1 para activar 2X $749'
          : qty === 2
            ? 'Falta 1 para activar 3X $949'
            : '✓ Mejor precio activado · $316.33 c/u';

      progressBlocks.forEach((block) => {
        const message = block.querySelector('[data-ar-product-combo-progress-message]');
        const count = block.querySelector('[data-ar-product-combo-progress-count]');
        const bar = block.querySelector('[data-ar-product-combo-progress-bar]');

        if (message) message.textContent = progressMessage;
        if (count) count.textContent = `${step} / 3`;
        if (bar) bar.style.width = `${pct}%`;
        block.classList.toggle('is-complete', qty >= 3);
      });
    } catch (_) {
      progressBlocks.forEach((block) => {
        const message = block.querySelector('[data-ar-product-combo-progress-message]');
        const count = block.querySelector('[data-ar-product-combo-progress-count]');
        const bar = block.querySelector('[data-ar-product-combo-progress-bar]');
        if (message) message.textContent = 'Agrega 2 y paga $749';
        if (count) count.textContent = '0 / 3';
        if (bar) bar.style.width = '0%';
      });
    }
  };

  const scheduleProductComboProgressUpdate = (delay = 0) => {
    window.setTimeout(updateProductComboProgress, delay);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateProductComboProgress, { once:true });
  } else {
    updateProductComboProgress();
  }

  document.addEventListener('cart:updated', updateProductComboProgress);
  document.addEventListener('cart:refresh', updateProductComboProgress);
  window.addEventListener('pageshow', updateProductComboProgress);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateProductComboProgress();
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('button[id^="ProductSubmitButton-"], [data-ar-sticky-action]')) {
      scheduleProductComboProgressUpdate(1100);
    }
  }, true);
})();
